import { render, staticRenderFns } from "./FormMonitoring.vue?vue&type=template&id=2aaa4dbc&"
import script from "./FormMonitoring.vue?vue&type=script&lang=js&"
export * from "./FormMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports